<template>
  <div
    class="w-full rounded-3xl mb-5 border-2 bg-white !border-[#2191da] p-5 lg:p-7 lg:pb-10 gap-7 grid content-start max-w-[400px]"
  >
    <div class="w-full flex justify-between items-center">
      <h2 class="font-black text-[#3057B4] text-3xl md:text-2xl font-openSans">Password Reset</h2>
    </div>

    <form class="w-full px-3 grid gap-7 content-start">
      <v-alert outline :model-value="!!message" :type="status == 'success' ? 'success' : 'error'">{{
        message
      }}</v-alert>
      <v-text-field
        v-model="formData.email"
        class="!border-2 !border-primary-dark px-2 py-1 rounded-md"
        :disabled="loadingResponse"
        v-on:keyup.enter="onEnterKey"
        @keydown.enter.prevent
        name="email"
        label="Email"
        type="email"
        variant="plain"
        :hide-details="true"
      />

      <div class="w-full grid gap-2">
        <v-btn
          :disabled="!formData.email || loadingResponse"
          variant="flat"
          class="!py-3 !bg-[#3057B4] !font-openSans !font-black !text-xl !capitalize !text-white !h-auto !tracking-normal"
          @click="passwordReset"
          :loading="loadingResponse"
          >Recover Password
        </v-btn>

        <a class="cursor-pointer text-[grey] text-left font-openSans text-sm" v-on:click="goLogin">
          Already have an account? Login
        </a>
      </div>
    </form>

    <div class="flex justify-center divide-x divide-[#2258bb] px-3">
      <a
        class="cursor-pointer text-[#2258bb] font-openSans underline text-left px-2 text-sm"
        :href="webBaseUrl+'/terms_of_use/'"
        target="_blank"
        >Terms of Service</a
      >
      <a
        class="cursor-pointer text-[#2258bb] font-openSans underline text-left px-2 text-sm"
        :href="webBaseUrl+'/privacy-policy/'"
        target="_blank"
        >Privacy Policy</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { passwordReset } from '@/actions/auth';
import { usePayloadStore } from '@/stores/payload';

export default class PasswordResetForm extends Vue {
  public loadingResponse = false;

  public webBaseUrl = process.env.WEB_BASE_URL;

  public formData = {
    email: ''
  };

  public status = '';

  public message = '';

  public goLogin() {
    window.location.href = '/accounts/login';
  }

  private payloadStore = usePayloadStore();

  public onEnterKey = () => {
    if (this.formData.email && !this.loadingResponse) {
      this.passwordReset();
    }
  }

  public passwordReset = () => {
    this.loadingResponse = true;
    passwordReset(this.formData)
      .then((res: any) => {
        if (res.error) {
          this.status = 'error';
          this.message = 'An error occurred while resetting your password. Please try again.';
          this.loadingResponse = false;
        } else {
          this.status = 'success';
          this.message = 'A password reset link has been sent to your email account.';
          this.loadingResponse = false;
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((err) => {
        this.status = 'error';
        this.message = 'An error occurred while resetting your password. Please try again.';
        this.loadingResponse = false;
      });
  };
}
</script>
